const InflateComponents = require('./InflateComponents');
const withReduxProvider = require('./wrapWithReduxProvider');
const withRootComponentProps = require('./withRootComponentProps');


Sephora.Util.InflatorSPA = {};

const renderRootComponent = component => {
    const { displayName } = withReduxProvider(component);
    const element = document.body.querySelector(`[rootid="${displayName}"]`);

    if (element) {
        const componentWithProps = withReduxProvider(withRootComponentProps(component, displayName));
        InflateComponents.render(componentWithProps, null, element);
    }
};

// require.ensure is used to package nested requires in components.chunk.js
// rather than priority.bundle.js in order to keep priority.bundle.js lean
const renderRootComponents = () => require.ensure([], require => {
    const SpaUtils = require('../Spa');
    const Header = require('../../components/Header/Header');
    const GlobalModalsWrapper = require('../../components/GlobalModals/GlobalModalsWrapper/GlobalModalsWrapper');
    const GlobalContent = require('../../components/GlobalContent/GlobalContent');
    const isSpaPage = SpaUtils.isSpaTemplate(Sephora.renderedData.template);
    let Page;

    if (isSpaPage) {
        Page = require('../../SpaApplication');
    } else {
        Page = require('pages/' + Sephora.renderedData.template);
    }

    renderRootComponent(Header);
    renderRootComponent(Page);
    renderRootComponent(GlobalModalsWrapper);
    renderRootComponent(GlobalContent);

    Sephora.Util.InflatorComps.services.loadEvents.HydrationFinished = true;
    const { HydrationFinished } = require('./Events');
    window.dispatchEvent(new CustomEvent(HydrationFinished));
}, 'components');

// require.ensure is used to package nested requires in postload.chunk.js
// rather than priority.bundle.js or components.chunk.js in order to keep them lean
const renderPostLoadRootComponents = () => require.ensure([], () => {
    const Footer = require('../../components/Footer');
    const { PostloadedGAdTagList } = require('../../components/GAdTag');
    const SmartChat = require('../../components/SmartChat');

    renderRootComponent(Footer);
    renderRootComponent(PostloadedGAdTagList);
    renderRootComponent(SmartChat);
}, 'postload');

module.exports = {
    renderPostLoadRootComponents,
    renderRootComponents
};
